<div class="flex border border-gray-700 rounded-lg overflow-hidden bg-black/30 p-0.5 gap-1">
  @for (o of options(); track o.value) {
    <button type="button" class="animate-all grow block px-4 py-4 text-center rounded bg-black hover:bg-red-500 uppercase cursor-pointer"
            [class.active]="value()==o.value"
            (click)="value.set(o.value)">{{ o.label }}
    </button>
  }
</div>
